export default function useYmTriggers() {
	const runtimeConfig = useRuntimeConfig();

	function hitGoToAuto() {
		const YM = (window as typeof window & { ym: Function })?.ym;
		if (YM) {
			YM(runtimeConfig.public.YM_ID, 'reachGoal', 'go_to_auto');
		}
	}

	function hitGoToAvia() {
		const YM = (window as typeof window & { ym: Function })?.ym;
		if (YM) {
			YM(runtimeConfig.public.YM_ID, 'reachGoal', 'go_to_avia');
		}
	}

	function hitOrderNow() {
		const YM = (window as typeof window & { ym: Function })?.ym;
		if (YM) {
			YM(runtimeConfig.public.YM_ID, 'reachGoal', 'order_now');
		}
	}

	function hitCallMe() {
		const YM = (window as typeof window & { ym: Function })?.ym;

		if (YM) {
			YM(runtimeConfig.public.YM_ID, 'reachGoal', 'call_me');
		}
	}

	return {
		hitCallMe,
		hitOrderNow,
		hitGoToAuto,
		hitGoToAvia
	};
}
